import React from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Trans, useTranslation } from "react-i18next"
import theme from "lib/material-ui/theme"
import { styled } from "@mui/material/styles"
import { OPEN_SEND_OTP_BOTTOM_SHEET, SHOW_NO_EMAIL_FOUND_MODAL } from "constants/events"
import { useAppSelector } from "appRedux/hooks"
import {
  updateForgetPasswordStep,
  updateShowNoEmailFoundModal,
  updateShowPasswordChangedSuccessfullyModal
} from "appRedux/slices/resetPasswordSlice"
import useEventListener from "hooks/useEventListener"
import { useAuth } from "context/AuthContext"
import SuccessIcon from "components/atoms/_icons/SuccessIcon"
import WarningRoundedIcon from "components/atoms/_icons/WarningRoundedIcon"
import Dialog from "components/atoms/Dialog"
import ForgetPasswordBottomSheet from "components/organisms/ResetPasswordFlow/ForgetPasswordBottomSheet"
import ChangePasswordBottomSheet from "components/organisms/ResetPasswordFlow/ChangePasswordBottomSheet"
import SendOTPBottomSheetForLoggedInUser
  from "components/organisms/ResetPasswordFlow/SendOTPBottomSheetForLoggedInUser"
import SendOTPBottomSheetForLoggedOutUser
  from "components/organisms/ResetPasswordFlow/SendOTPBottomSheetForLoggedOutUser"

export default function ResetPasswordFlow() {
  const step = useAppSelector((state) => state.resetPassword.step)
  const showPasswordChangedSuccessfullyModal = useAppSelector((state) => state.resetPassword.showPasswordChangedSuccessfullyModal)
  const showNoEmailFoundModal = useAppSelector((state) => state.resetPassword.showNoEmailFoundModal)
  const enteredEmail = useAppSelector((state) => state.resetPassword.email)

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { isAuthenticated, user } = useAuth()

  useEventListener(document, OPEN_SEND_OTP_BOTTOM_SHEET, handleOpenSendOTPBottomSheet)

  useEventListener(document, SHOW_NO_EMAIL_FOUND_MODAL, handleToggleNoEmailFoundModal)

  function handleOpenSendOTPBottomSheet() {
    dispatch(updateForgetPasswordStep(1))
  }

  function handleToggleNoEmailFoundModal() {
    dispatch(updateShowNoEmailFoundModal())
  }

  function handleEndForgetPasswordFlow() {
    dispatch(updateForgetPasswordStep(-1))
  }

  function handleClosePasswordChangedSuccessfullyModal() {
    dispatch(updateShowPasswordChangedSuccessfullyModal())
  }

  function handleNavigateToEditProfilePage() {
    handleCloseNoEmailFoundModal()
    navigate("/account/edit")
  }

  function handleCloseNoEmailFoundModal() {
    dispatch(updateShowNoEmailFoundModal())
  }

  return (
    <>
      <ChangePasswordBottomSheet
        show={step === 0}
        onOpen={() => {
        }}
        onClose={handleEndForgetPasswordFlow}
      />
      <SendOTPBottomSheetForLoggedInUser
        show={step === 1 && isAuthenticated}
        onOpen={() => {
        }}
        onClose={handleEndForgetPasswordFlow}
      />
      <SendOTPBottomSheetForLoggedOutUser
        show={step === 1 && !isAuthenticated}
        onOpen={() => {
        }}
        onClose={handleEndForgetPasswordFlow}
      />
      <ForgetPasswordBottomSheet
        show={step === 2}
        showEmail={!isAuthenticated}
        email={isAuthenticated ? user?.email : enteredEmail}
        onOpen={() => {
        }}
        onClose={handleEndForgetPasswordFlow}
      />
      <Dialog
        message={t("auth.passwordChangedSuccessfully")}
        icon={<SuccessIcon/>}
        buttons={[
          {
            label: t("general.understood"),
            mode: "primary",
            loading: false,
            onClick: handleClosePasswordChangedSuccessfullyModal
          }
        ]}
        open={showPasswordChangedSuccessfullyModal}
        onClose={handleClosePasswordChangedSuccessfullyModal}
      />
      <Dialog
        message={<Trans
          i18nKey={"auth.enterEmailForPasswordRecovery"}
          components={{
            strong: <strong style={{
              color: theme.palette.gray["15"],
              fontWeight: 700
            }}/>
          }}
        />}
        icon={<WarningRoundedIcon/>}
        buttons={[
          {
            label: t("general.understood"),
            mode: "white",
            loading: false,
            disabled: false,
            onClick: handleCloseNoEmailFoundModal
          },
          {
            label: t("user.updateProfile"),
            mode: "primary",
            loading: false,
            disabled: false,
            onClick: handleNavigateToEditProfilePage
          }
        ]}
        open={showNoEmailFoundModal}
        onClose={handleCloseNoEmailFoundModal}
      />

    </>
  )
}

